import { render, staticRenderFns } from "./BaseInputCheckbox.vue?vue&type=template&id=fd97ad50&scoped=true"
import script from "./BaseInputCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseInputCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd97ad50",
  null
  
)

export default component.exports